<template>
	<tr class="ms-tr">
		<td
			v-for="(col, indexCol) in columns"
			:key="col.dataField"
			class="ms-td"
			:class="[indexCol == 0 ? `level-${dataRow.level}` : null]"
			@dblclick="row_dblclick"
			:style="styleWidth(col)"
			@click="row_click"
		>
			<!-- Nếu có template truyền vào thì vẽ theo template -->
			<div v-if="col.template">
				<component
					:is="col.template"
					:data="dataRow"
					:column="col"
					v-if="col.template"
					v-bind="col.templateProps"
					@dataAction="handleAction"
				></component>
			</div>
			<!-- Nếu là côt đầu tiên -->
			<div
				v-else-if="indexCol == 0"
				class="flex items-center"
				:class="{
					'font-bold': dataRow.Childrens && dataRow.Childrens.length > 0,
				}"
			>
				<div
					v-if="dataRow.Childrens && dataRow.Childrens.length > 0"
					class="mi mi-24 ms-mg-8px"
					:class="`mi-tree-${dataRow.expanded ? 'hidden' : 'show'}`"
					@click="toggle_click(dataRow)"
				></div>
				<div class="mi-24 ms-mg-8px" v-else></div>
				<div class>
					<span>{{
						dataRow[col.dataField]
							| formatData({
								formatType: col.formatType,
								enumName: col.enumName,
								dataRow: dataRow,
							})
					}}</span>
				</div>
			</div>
			<div v-else :class="[col.cssClass, `text-${col.align}`]">
				<span
					@click="
						typeof col.drilldown == 'function' ? col.drilldown(dataRow) : null
					"
					>{{
						dataRow[col.dataField]
							| formatData({
								formatType: col.formatType,
								enumName: col.enumName,
								dataRow: dataRow,
							})
					}}</span
				>
			</div>
		</td>
		<td
			v-if="(rowActions && rowActions.length > 0) || rowActionsWidget"
			class="ms-td ms-row-actions-cell"
			@click.stop
		>
			<div class="ms-row-actions" v-if="rowActionsWidget">
				<component
					:is="rowActionsWidget"
					:dataRow="dataRow"
					:data="dataRow"
					@widgetEvent="widgetEvent"
					@dataAction="handleAction"
				></component>
			</div>
			<div class="ms-row-actions" v-else-if="visibleRowActions.length > 0">
				<row-action-icon-button
					v-for="(action, actionIndex) in visibleRowActions"
					:key="actionIndex"
					:iconClass="buildRowActionIconClass(action)"
					:tooltip="buildRowActionTooltip(action)"
					@click.native.stop="onRowActionClick(action)"
				></row-action-icon-button>
			</div>
		</td>
	</tr>
</template>
<script>
import RowActionIconButton from '@/views/widget/RowActionIconButton.vue';
export default {
	name: 'msTr',
	components: {
		RowActionIconButton,
	},
	props: {
		dataRow: {},
		//Cấu hình các cột truyền vào
		columns: {
			type: Array,
		},

		isActive: {
			type: Boolean,
			default: false,
		},
		isShowExpanded: {
			type: Boolean,
			default: true,
		},
		/**
		 * Danh sách action hiển thị nổi lên (overlay) khi hover vào dòng, cấu hình giống hệt
		 * gridOptions.rowActions của msGridViewer: { key, icon, tooltip, show, onClick }
		 */
		rowActions: {
			default: null,
			type: Array,
		},
		/**
		 * Component widget tùy chỉnh render vào overlay khi hover (thay cho rowActions),
		 * giống hệt gridOptions.rowActionsWidget của msGridViewer
		 */
		rowActionsWidget: {
			default: null,
		},
	},
	computed: {
		/**
		 * Lọc ra action còn hiển thị cho dòng hiện tại (action.show trả về false thì ẩn)
		 */
		visibleRowActions() {
			const me = this;
			if (!me.rowActions || me.rowActions.length == 0) return [];
			return me.rowActions.filter((action) => {
				if (typeof action.show == 'function') {
					return action.show(me.dataRow);
				}
				return true;
			});
		},
	},
	methods: {
		handleAction(data) {
			const me = this;
			me.$emit('dataAction', data);
		},
		//Emit sự kiện từ rowActionsWidget ra ngoài
		widgetEvent(data, event) {
			const me = this;
			me.$emit('widgetEvent', data, event);
		},
		/**
		 * Build class icon đầy đủ cho row action (RowActionIconButton chỉ nhận 1 class string)
		 */
		buildRowActionIconClass(action) {
			return `mi-new-v2 mi-16 ${action.icon}`;
		},
		/**
		 * Build tooltip cho row action: hỗ trợ cả string tĩnh và function nhận dataRow
		 */
		buildRowActionTooltip(action) {
			const me = this;
			if (!action.tooltip) return '';
			return typeof action.tooltip == 'function'
				? action.tooltip(me.dataRow)
				: action.tooltip;
		},
		/**
		 * Xử lý click vào 1 row action, emit ra ngoài kèm dataRow để nơi dùng cây tự xử lý nghiệp vụ
		 */
		onRowActionClick(action) {
			const me = this;
			if (typeof action.onClick == 'function') {
				action.onClick(me.dataRow);
			}
			me.$emit('rowAction', { key: action.key, dataRow: me.dataRow });
		},
		styleWidth(col) {
			if (col.autoResize) {
				return {
					minWidth: `${col.width}px`,
				};
			}
			return {
				width: `${col.width}px`,
				minWidth: `${col.width}px`,
			};
		},
		toggle_click() {
			const me = this;
			me.dataRow.expanded = !me.dataRow.expanded;
			me.changeVisibleTr(me.dataRow, me.dataRow.expanded);
		},
		changeVisibleTr(data, expanded) {
			const me = this;
			let childNodes = data.Childrens;
			if (childNodes && childNodes.length > 0) {
				childNodes.forEach((item) => {
					me.$set(item, 'isHide', !expanded);
					me.changeVisibleTr(item, expanded);
				});
			}
		},
		//Emit sự kiện click row ra ngoài grid
		row_click(e) {
			const me = this;
			me.$emit('click', me.dataRow, e);
		},

		//Emit sự kiện dblclickRow ra ngoài grid
		//Created by LTDAT(13/06/2020)
		row_dblclick(e) {
			const me = this;
			me.$emit('dblclick', me.dataRow, e);
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msTrTreeViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msTrTreeViewer.scss';
}
</style>